import { Engagement } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";
import { queriesEngagements } from "@query";

/**
 * Indexes the account's engagement templates by id.
 *
 * The `searchPayeeRows` / `searchPayerRows` engagement item is an allowlist of
 * six fields and no longer carries `engagementType`; the row keeps
 * `engagementId`, so the template is the only remaining source (WIN-16077). The
 * list is small and account-wide, so it is fetched once and shared, the same way
 * `ModalCreateWorkLogPayer` already resolves an engagement's type.
 *
 * **Payer-seat only.** `listEngagements` returns the caller's own account's
 * templates, so a contractor cannot resolve their payer's engagement this way —
 * the contractor work-log surfaces leave the type unset instead.
 */
export const useEngagementsMap = (enabled = true) => {
  const queryEngagements = queriesEngagements.listEngagements.useQueryAll(
    undefined,
    { enabled }
  );

  const engagements = queryEngagements.flatData;

  return useMemo(() => {
    const map = new Map<string, Engagement>();
    engagements.forEach(engagement => {
      if (engagement.id) {
        map.set(engagement.id, engagement);
      }
    });
    return map;
  }, [engagements]);
};
